// export const base_Url = 'https://sore-rose-python-gear.cyclic.app'
// export const base_Url = 'http://localhost:8000'
// export const base_Url = 'https://server-eta-lovat-90.vercel.app/'
export const base_Url = 'https://admin-dynamic-backend.onrender.com'